'use client';

import useEmblaCarousel from 'embla-carousel-react';
import { useEffect, useState, ReactNode, useRef } from 'react';
import Autoplay from 'embla-carousel-autoplay';

interface CarouselProps {
  children: ReactNode;
}

export default function Carousel({ children }: CarouselProps) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const slides = Array.isArray(children) ? children : [children];
  const autoplay = useRef(
    Autoplay({
      delay: 3000,
      stopOnInteraction: false,
    })
  );

  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [
    autoplay.current,
  ]);

  useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => setSelectedIndex(emblaApi.selectedScrollSnap());
    emblaApi.on('select', onSelect);
  }, [emblaApi]);

  return (
    <div className="w-full">
      <div ref={emblaRef} className="overflow-hidden rounded-3xl">
        <div className="flex">
          {slides.map((child, index) => (
            <div key={index} className="flex-shrink-0 w-full min-w-0 mr-2">
              {child}
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-center gap-2 my-4">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => emblaApi?.scrollTo(index)}
            className={`rounded-full transition-all ${
              index === selectedIndex
                ? 'w-6 h-2 bg-crunchies-red'
                : 'w-2 h-2 bg-gray-300'
            }`}
          />
        ))}
      </div>
    </div>
  );
}
